var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-wrapper',{staticClass:"py-8"},[_c('number-chart',{attrs:{"is-loading":_vm.isLoading,"value":_vm.total,"title":_vm.title,"hint":_vm.hint,"id":"automation-rate-number"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }